import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class SetRaceContestantStartingTimeRequest implements ISerialize {
    public RaceContestantIds: number[];

    public StartingTime: Date | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { RaceContestantIds?: number[]; StartingTime?: Date | null }) {
        this.RaceContestantIds = values.RaceContestantIds ?? [];

        this.StartingTime = values.StartingTime ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"RaceContestantIds": [ ${this.RaceContestantIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"StartingTime": ${this.StartingTime ? '"' + formatDateIso(this.StartingTime) + '"' : null}` +
            '}'
        );
    }

    /**
     * Creates an instance of SetRaceContestantStartingTimeRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { RaceContestantIds?: number[]; StartingTime?: Date | null }): SetRaceContestantStartingTimeRequest {
        return new SetRaceContestantStartingTimeRequest(values);
    }

    public static _FromServerJson(json: any): SetRaceContestantStartingTimeRequest {
        return new SetRaceContestantStartingTimeRequest({
            RaceContestantIds: json.RaceContestantIds,
            StartingTime: json.StartingTime ? (json.StartingTime instanceof Date ? json.StartingTime : new Date(json.StartingTime)) : null,
        });
    }

    /**
     * Creates an instance of SetRaceContestantStartingTimeRequest from another instance of SetRaceContestantStartingTimeRequest.
     * @param other The SetRaceContestantStartingTimeRequest you want to clone
     * @returns A cloned SetRaceContestantStartingTimeRequest
     */
    public static FromOther(other: SetRaceContestantStartingTimeRequest): SetRaceContestantStartingTimeRequest {
        return SetRaceContestantStartingTimeRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SetRaceContestantStartingTimeRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'SetRaceContestantStartingTimeRequest';
}
